import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { layoutFloorModulesAtom } from '@store';
import { Skeleton } from '@ui';

import { LayoutModule } from './LayoutModule';
import * as css from './LayoutModuleList.css';

const MAX_MODULES_PER_PAGE = 4;

export const LayoutModuleList = () => {
    const floorModules = useAtomValue(layoutFloorModulesAtom);

    const gridModules = useMemo(() => floorModules?.slice(0, MAX_MODULES_PER_PAGE), [floorModules]);
    const count = (gridModules?.length ?? 0) - 1;

    return (
        <main className={css.grid}>
            {gridModules?.map((module, index) => (
                <LayoutModule key={module.childUiNodeId} index={index} isLast={index === count} module={module} />
            )) || (
                <>
                    <Skeleton className={css.skeletonGridItem} shade={800} />
                    <Skeleton className={css.skeletonGridItem} shade={800} />
                    <Skeleton className={css.skeletonGridItem} shade={800} />
                    <Skeleton className={css.skeletonGridItem} shade={800} />
                </>
            )}
        </main>
    );
};
